import { TYPES_OF_TILE } from '../../../../../constants'

export const ALL_MIGRATIONS = {
	[TYPES_OF_TILE.DATA_GRID]: {
		showInDashboard: { defaultEnabled: true },
	},
	[TYPES_OF_TILE.PLOTTING_MAP]: {
		showInDashboard: { defaultEnabled: true },
	},

	[TYPES_OF_TILE.EMPLOYEE_SUMMARY_TILE]: {
		showAgenda: { defaultEnabled: true },
	},
}

export function isMigrateValue(currentOptionChecked, type) {
	if (!type || !ALL_MIGRATIONS[type]) return []

	const migrations = ALL_MIGRATIONS[type]
	const allOptionKeys = Object.keys(migrations)

	// Lọc ra những option nằm trong migration list
	return allOptionKeys.includes(currentOptionChecked)
}

export function getDefaultMigratedOptionValue({ key, tileType }) {
	if (!tileType || !ALL_MIGRATIONS[tileType]) return false
	const migrations = ALL_MIGRATIONS[tileType]
	return migrations[key]?.defaultEnabled || false
}
